// App.jsxAdd commentMore actions
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBanks, fetchCities, fetchDealers, fetchItems, fetchSalesPersons, fetchVariants, fetchSource, fetchCorporateClients, fetchMake, fetchModel, fetchPartsVariant, fetchPartsColors, fetchPartsCategory, fetchVendors, fetchTax, fetchDiscount } from "./core/redux/action";
import AllRoutes from "./Router/router";

export default function App() {
    let renderCount = 0;
    renderCount++;
    console.log("App Render Count:", renderCount)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCities());
        dispatch(fetchBanks());
        dispatch(fetchDealers());
        dispatch(fetchItems());
        dispatch(fetchSalesPersons());
        dispatch(fetchVariants());
        dispatch(fetchCorporateClients());
        dispatch(fetchSource());
        dispatch(fetchMake());
        dispatch(fetchModel());
        dispatch(fetchPartsVariant());
        dispatch(fetchPartsColors());
        dispatch(fetchPartsCategory());
        dispatch(fetchVendors());
        dispatch(fetchTax());
        dispatch(fetchDiscount());
    }, []);

    return <AllRoutes />;
}